import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { RadioGroupInput } from 'Packages/FacetDesign/Components/RadioGroupInput';
import fr from 'facet-rest';
import TextFieldWithLabelAbove from 'Components/ComponentLibrary/Components/Uncategorized/TextFieldWithLabelAbove';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import { DollarNumberFormatUsd } from 'Components/UI/DollarUSDInput';
import SelectFieldWithLabelAbove from 'Components/ComponentLibrary/Components/Uncategorized/SelectFieldWithLabelAbove';
import SearchableFinancialInstitutionQuerySelect
  from 'Components/ComponentLibrary/Components/Uncategorized/SearchableFinancialInstitutionQuerySelect';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';

const readonlyFieldsToShow = ['searchableFinancialInstitutionID', 'title', 'name'];

export const DigitalOnboardingBalanceSheetOverride = fr.metaOverride({ base: BaseOverrideNoHidden })
  .override({ name: 'title' }, {
    _component: () => DialogTitle,
  }, { ordinal: 200 })
  .override({ name: name => !readonlyFieldsToShow.includes(name), required: false }, { hidden: true }) // hide non-required fields
  .override({ name: name => !readonlyFieldsToShow.includes(name), readonly: true }, { hidden: true }, overrideReadOnly) // hide readonly fields
  .nameOverride('name', {
    _component: () => TextFieldWithLabelAbove,
  }, { ordinal: 300 })
  .override({ required: true }, {
    _customProps: { helperText: '' },
  }, { overrideReadOnly })
  .override({ hint: 'usd' }, {
    _component: () => TextFieldWithLabelAbove,
    _customProps: {
      InputProps: {
        inputComponent: DollarNumberFormatUsd,
      },
      helperText: '',
    },
  }, { ordinal: 250 })
  .nameOverride(['ownerClientId'], {
    _component: () => RadioGroupInput,
    _customProps: { direction: 'row' },
  }, overrideReadOnly)
  .nameOverride(['ownerNotes'], {
    _component: () => TextFieldWithLabelAbove,
  }, { ordinal: 250 });


export const DigitalOnboardingAccountInfoOverride = fr.metaOverride({ base: DigitalOnboardingBalanceSheetOverride })
  .nameOverride(['active', 'beneficiaryId'], {
    _component: () => RadioGroupInput,
    _customProps: { direction: 'row' },
  }, overrideReadOnly)
  .nameOverride(['otherFinancialInstitution'], {
    _component: () => TextFieldWithLabelAbove,
  }, { ordinal: 250 })
  .nameOverride(['accountSubType'], {
    _component: () => SelectFieldWithLabelAbove,
  }, { ordinal: 500 })
  .override({ name: 'searchableFinancialInstitutionID' }, {
    _component: () => SearchableFinancialInstitutionQuerySelect,
  }, { ordinal: 500 })
  .nameOverride(['otherFinancialInstitution'], {
    _component: () => TextFieldWithLabelAbove,
  }, { ordinal: 250 })
  .nameOverride(['creditCardPaymentType', 'fsaType'], {
    _component: () => RadioGroupInput,
    _customProps: { direction: 'column' },
  }, overrideReadOnly);
